/**
 * Analytics Module — NF Tracker
 * Centralized Google Analytics (GA4) configuration and tracking helper functions.
 */

export const GA_MEASUREMENT_ID = 'G-DCBVVETXNB';

/**
 * Initialize Google Analytics GA4 gtag.js script and global dataLayer functions.
 */
export function initAnalytics() {
  if (typeof window === 'undefined') return;

  // Prevent duplicate script injection
  if (window.gtagInitialized) return;
  window.gtagInitialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false // SPA router tracks page views dynamically
  });

  // Dynamically inject GA4 script tag during browser idle time to avoid competing with critical rendering
  const injectScript = () => {
    if (document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`)) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  };

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(injectScript, { timeout: 2000 });
  } else {
    setTimeout(injectScript, 1000);
  }
}

/**
 * Track a page view event in GA4 for single-page app (SPA) navigations.
 * @param {string} pagePath Route path (e.g. '#notas', '#feedback', '#family')
 * @param {string} [pageTitle] Page title
 */
export function trackPageView(pagePath, pageTitle) {
  if (typeof window === 'undefined' || !window.gtag) return;

  const path = pagePath || window.location.hash || '/';
  window.gtag('event', 'page_view', {
    page_title: pageTitle || document.title,
    page_location: window.location.href,
    page_path: path
  });
}

/**
 * Track a custom user action event in GA4.
 * @param {string} eventName Event name
 * @param {Object} [eventParams] Additional event parameters
 */
export function trackEvent(eventName, eventParams = {}) {
  if (typeof window === 'undefined' || !window.gtag) return;

  window.gtag('event', eventName, eventParams);
}
